var jquery = require("/js/lib/jquery");

window.$ = window.jQuery = jquery;

import wsCall, { wsCallAsync } from './wsCall';
import appData from './appData';
import { getParameterByName } from './util';
import 'babel-polyfill';
import Dialog from './dialog';

function App() {
  var self = this;
}

App.prototype.init = function() {
  var self = this;

  appData.init({
    watch: {
    },
    computed: {
    },
    methods: {
    },
    mounted: function() {
    }
  });

  $('#forgotPasswordButton').on('click', function() {
    $('#forgotPasswordSubmit').click();
  });
  $('#forgotPasswordForm').on('submit', async function(e) {
    e.preventDefault();

    $('#forgotPasswordButton').addClass('is-loading');

    try {
      let result = await wsCallAsync({
        url: '/account/forgotPassword',
        data: {
          email: appData.vm.loginEmail
        }
      });
      appData.vm.dialog.info.title = 'Reset Password';
      appData.vm.dialog.info.message = 'Please check your email and click the link to reset your password.';
      var defer = Dialog.showInfo();

      $.when(defer).done(function() {
        window.location = '/';
      });
    }
    catch (result) {
    }

  });

};

var app = new App();

app.init();

export default app;

